import { Marker, icon, divIcon, } from 'leaflet';
import { Injectable } from '@angular/core';
import { FileDataService } from './file-data.service';
import * as L from 'leaflet';
import { Router } from '@angular/router';

@Injectable()
export class MapMarkerService {
  distanceWaypoint:any;
  constructor(private fileService: FileDataService,) { }

  generateMarker(lat: number, long: number, tooltipContent: string, popUpContent: string, markerIndex?: number, waypointlength?: number) {
    const routeIcon = divIcon({
      iconSize: [0, 0],
      iconAnchor: [4, 4],
      popupAnchor: [-6, -5],
      html: this.showMarkerContent(markerIndex, waypointlength),
      className: "base-number-marker"
    })
    const searchIcon = icon({
      iconSize: [52, 62],
      iconAnchor: [21, 48],
      popupAnchor: [5, -25],
      iconUrl: 'assets/images/pin.svg',
    })

    const displayIcon = typeof (markerIndex) === 'number' ? routeIcon : searchIcon;
    const marker = new Marker([lat, long], { draggable: true }).setIcon(displayIcon);
    marker.bindPopup(popUpContent);
    marker.bindTooltip(tooltipContent);
    marker['id'] = markerIndex;
    marker.on('popupopen', () => {
      marker.unbindTooltip();    
   
    });
    marker.on('click', () => {
      
      // L.DomEvent.stopPropagation(e);
      // console.log(L.DomEvent.stopPropagation(e));
      this.fileService.selectrdMarker(marker);
  
      
    });
    marker.on('popupclose', () => {
      marker.bindTooltip(tooltipContent);
    });
    marker.on('dragstart', () => {
      //console.log("dragstart");
      //let dragon= true;  
      this.fileService.isValidMarker(true);
    })
    marker.on('drag', () => {
      // onsole.log("drag");
    })
    marker.on('dragend', () => {
      //dragging issue
      this.fileService.changesOnDrag(marker);
      //console.log("dragend");
    });
    marker.setZIndexOffset(1000);
    return marker;
  }
  showMarkerContent(markerIndex: number, totalCount: number): string | false | HTMLElement {
    let numberedMarker: string | boolean = '';
    if (markerIndex === 0) {
      numberedMarker = false;
    } else if (markerIndex === 1) {
      numberedMarker = `<div class="number-marker green" <a   id="selectwaypoint"></a> ${markerIndex}</div>`;
    } else if (markerIndex > 1 && markerIndex < totalCount) {
      numberedMarker = `<div class="number-marker yellow">${markerIndex}</div>`;
    } else if (markerIndex === totalCount) {
      numberedMarker = `<div class="number-marker red">${markerIndex}</div>`;
    }
    return numberedMarker;
  }

  generatePopupContent(lat: string, long: string, itineraryName: string, isAddItinerary: boolean, indexNumber: number): string {    
  
    const addItinerary = `<p><a id="addItinerary" style="cursor:pointer">Add to Itinerary</a></p>`;
    const deleteItinerary = `<p><a href="javascript:void(0)" lat="${lat}" lon="${long}" id="deleteWaypoint">Delete</a> </p><p><strong>waypoint:</strong> ${indexNumber} </p>`
    const basicDescription = `<p> <strong>Location: </strong>
      <span lat="${lat}" lon="${long}" id="editWaypointName" contenteditable="true"> ${itineraryName}</span> </p>
      <p><strong>Latitude: </strong> ${lat} </p >
      <p><strong>Longitude: </strong> ${long}</p > 
      
      `
    return isAddItinerary ? basicDescription + addItinerary : deleteItinerary + basicDescription;
  }
}
